
import common from '@/store/common'
import { getKey } from '../utils'

export default {
  async inserted (el, _binding, _vnode) {
    if (getKey('channel') !== 'API-rosewallet') return
    const { success, data } = await common.actions.rosewalletConfig()
    if (success && data?.jumpTmdHomeFloatViewShow === 'N') {
      el.parentNode.removeChild(el)
    }
  }
}

